module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-9-55cb401b2a4975477c99606d147fb870.svg";